import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/input-comment-box.scss'

function Element({
  value,
  className,
  placeholder = '입력하세요.',
  disabled = false,
  onChange = () => {},
  register = null,
}) {
  // if ([true, 'true'].includes(disabled)) {
  //   disabled = true;
  // }
  return (
    <>
      <div className="">
        <input
          type="text"
          className={'input-box ' + className}
          defaultValue={value}
          placeholder="내용을 입력하세요"
          onChange={onChange}
          {...register}
          //disabled={disabled}
        />
      </div>
    </>
  )
}

export default Element
